// Card wishlist heart — global relocation logic.
//
// Loaded site-wide from layout/theme.liquid (deferred), NOT from the product-card
// snippet's {% javascript %}. Horizon only bundles a snippet's {% javascript %} on
// pages where the snippet is server-rendered at initial load; on the PDP the product
// cards exist only inside the async-loaded "You may also like" (product-recommendations)
// section, so the snippet JS never loaded there and the WishlistSuite heart stayed
// hidden. Living here guarantees it runs on every page, and the persistent body
// MutationObserver catches cards whenever they appear (server-rendered OR async:
// recommendations, infinite scroll, filtering).

// Wishlist anchor: match its box to the card image's aspect ratio so the heart sits
// just below the image for ANY gallery ratio (square/portrait/landscape/adapt). It
// reuses the gallery's own --gallery-aspect-ratio; without this the box assumes square
// (1/1) and the heart mispositions on non-square images. The square CSS fallback keeps
// it correct if this never runs.
class CardWishlistAnchor extends HTMLElement {
  connectedCallback() {
    const gallery = this.closest('.product-card')?.querySelector('.card-gallery');
    if (!gallery) return;
    const ratio = getComputedStyle(gallery).getPropertyValue('--gallery-aspect-ratio').trim();
    if (ratio) this.style.aspectRatio = ratio;
  }
}

if (!customElements.get('card-wishlist-anchor')) {
  customElements.define('card-wishlist-anchor', CardWishlistAnchor);
}

// WishlistSuite integration: the app injects its heart button into the gallery. Move
// each button into its card's [data-wishlist-anchor] so it lands in the meta block
// (styled in snippets/product-card.liquid). Runs once; a MutationObserver catches
// buttons the app adds later (AJAX section renders, async recommendations, infinite
// scroll, filtering).
(function moveWishlistHearts() {
  const move = () => {
    for (const btn of document.querySelectorAll('.product-card-wishlist-btn')) {
      const card = btn.closest('.product-card, .card');
      if (!card) continue;
      const anchor = card.querySelector('[data-wishlist-anchor]');
      if (anchor && btn.parentElement !== anchor) {
        anchor.appendChild(btn);
        anchor.classList.add('card-wishlist--app');
      }
    }
  };

  const init = () => {
    move();
    new MutationObserver(move).observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
